import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import React, { useMemo } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { InterpreterDashboardSelector } from "slices/interpreter/dashboardSlice";
import { fetchInterpreterDashboardAppointments } from "slices/interpreter/dashboardSlice";
import { getEyeStyle, getBackgroundStyle } from "components/common/TableColor";
import moment from "moment";
import { userSelector } from "slices/userSlice";
const ListTable = ({ data, filters, setPageLength, searchTerm, setSearchTerm}) => {
  const dispatch = useDispatch();
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {},
  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [declineModal, setDeclineModal] = React.useState({
    show: false,
    item: {},
  });
  const [currentPage, setCurrentPage] = React.useState(1);

  const [sortConfig, setSortConfig] = React.useState({
    sortBy: "id",
    sortDirection: "desc",
  });
  const [sortFields, setSortFields] = React.useState([]);

  const [actionAccept, setActionAccept] = React.useState({
    show: false,
    item: {},
  });
  const {
    last_page: totalPages,
    current_page,
    per_page: pageLength,
    total,
  } = useSelector(InterpreterDashboardSelector);

  const handleAddScheduleListPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };
  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      });
      setSelectedItems([]);
      setSelectAll(false);
      hideConfirmDialog();
    } else {
      toast.error(message, {
        className: "errorToast",
      });
    }
  };
  const showConfirmDialog = () => {
    setDeclineModal(true);
    return;
  };
  const hideConfirmDialog = () => {
    setDeclineModal(false);
  };
  const handleDeclineConfirm = () => {
    // dispatch(declineVendorJobs({ schedule_id: declineModal?.item?.id }, submitCallback))
  };
  const handleChange = (e) => {
    const id = e.target.dataset.value;
    setSelectedItems(
      selectedItems.includes(id)
        ? selectedItems.filter((item) => item != id)
        : [...selectedItems, id]
    );
  };

  //#region TABLE HEAD
  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      dispatch(
        fetchInterpreterDashboardAppointments(currentPage, {
          sortBy: sortBy,
          sortDirection: dir,
          search: searchTerm,
          pageLength: pageLength,
          ...filters,
        })
      );
    };

    return (
      <tr>
        <th>#</th>
        <th>
          <TableHeaderItem
            title="appid"
            sortBy="appid"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Status"
            sortBy="status"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Service"
            sortBy="type"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Date"
            sortBy="datetime"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Language"
            sortBy="language"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Accounts"
            sortBy="accounts"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
      </tr>
    );
  }, [
    selectAll,
    searchTerm,
    sortFields,
    currentPage,
    sortConfig,
    selectedItems,
    pageLength,
    filters,
  ]);
  //#endregion

  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return data?.map((item, index) => (
      <AppointmentListItem
        item={item}
        index={index}
        handleAcceptButton={handleAcceptButton}
        handleDeclineShow={handleDeclineShow}
        current_page={current_page}
        pageLength={pageLength}
      />
    ));
  }, [selectedItems, data]);

  //#endregion

  const handleAcceptButton = React.useCallback((id) => {
    setActionAccept({
      show: true,
      item: { id },
    });
  }, []);

  const handleCloseActionButton = React.useCallback((id) => {
    setActionAccept({
      show: false,
      item: {},
    });
  }, []);

  const handleDeclineShow = React.useCallback((id) => {
    setDeclineModal({
      show: true,
      item: { id },
    });
  }, []);

  return (
    <div className="mt-4">
      <ListLayout
        heading={`dasboard appointments`}
        time={false}
        fullMainHead={"ms-3"}
        title=""
        renderTableHeader={renderTableHeader}
        renderTableContent={renderTableContent}
        fetchList={fetchInterpreterDashboardAppointments}
        selectedItems={selectedItems}
        handleDeclineConfirm={handleDeclineConfirm}
        refAddutton={refAddutton}
        addForm={addForm}
        showConfirmDialog={showConfirmDialog}
        handleAddPopUp={handleAddScheduleListPopUp}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        searchPlaceholder="Search in this table ..."
        addButtonDisabled={true}
        totalPages={totalPages}
        sortConfig={sortConfig}
        paginationParams={filters}
        noOfItems={total}
        pageLengthChange={setPageLength}
        defaultPageLength={pageLength}
      >
        {declineModal.show && (
          <ConfirmationModal
            onClose={hideConfirmDialog}
            isOpen={declineModal?.show}
            onConfirm={handleDeclineConfirm}
            confirmationText="Are you sure you want to Decline?"
          />
        )}
      </ListLayout>
    </div>
  );
};

const AppointmentListItem = React.memo(
  ({ item, index, current_page, pageLength }) => {
    const { user } = useSelector(userSelector);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serial = useMemo(() => {
      return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    // const getBackgroundStyle = (status) => {
    //     if (status === 'assigned') {
    //         return { background: '#785c9933' };
    //     } else if (status === 'available') {
    //         return { background: '#ffb82a33' };
    //     } else if (status === 'dnc') {
    //         return { background: '#3176a033' };
    //     } else if (status === 'cnc') {
    //         return { background: '#9623e033' };
    //     } else if (status === 'completed') {
    //         return { background: '#1AD59833' };
    //     } else if (status === 'cancelled') {
    //         return { background: '#e33a3133' };
    //     }
    // };

    console.log("item?.confirmation_status", user?.timezone?.name);

    const appointmentTime = moment(item?.datetime);
const now = moment();

const minutesDiff = appointmentTime.diff(now, 'minutes');

    const appointmentTimezoneName = item?.appointment_details?.timezone?.name;
    const interpreterTimezoneName = item?.interpreter?.timezone?.name || user?.timezone?.name;

    const formattedAppointmentDateTime = (() => {
      if (!item?.datetime) return "N/A";
      if (appointmentTimezoneName && interpreterTimezoneName) {
        return moment
          .tz(item.datetime, appointmentTimezoneName)
          .tz(interpreterTimezoneName)
          .format("MMM D, YYYY hh:mm A");
      }
      if (interpreterTimezoneName) {
        return moment.utc(item.datetime)
          .tz(interpreterTimezoneName)
          .format("MMM D, YYYY hh:mm A");
      }
      return moment(item.datetime).format("MMM D, YYYY hh:mm A");
    })();

let rowStyle = getBackgroundStyle(item?.status);

// 1. accepted
// if (item?.confirmation_status === 'accepted') {
//     rowStyle = getBackgroundStyle('accepted');
// }

// 2. link opened
if (item?.confirmation_status === 'link_opened') {
    rowStyle = {
        background: 'rgb(18 241 168 / 30%)'
    };
}

// 3. not opened + <= 30 min
else if (
    item?.confirmation_status !== 'link_opened' && item?.confirmation_status !== 'accepted' && item?.status !== 'cancelled' &&
    minutesDiff > 0 &&
    minutesDiff <= 30
) {
    rowStyle = { background: '#ffcccc' };
}

// 4. not opened + <= 12 hours
else if (
    item?.confirmation_status !== 'link_opened' && item?.confirmation_status !== 'accepted' && item?.status !== 'cancelled' &&
    minutesDiff > 30 &&
    minutesDiff <= 720
) {
    rowStyle = { background: '#fff3cd' };
}

const shouldBlink =
    item?.confirmation_status !== 'link_opened' &&
    item?.confirmation_status !== 'accepted' &&
    item?.status !== 'cancelled' &&
    minutesDiff > 0 &&
    minutesDiff <= 30;
    return (
      <tr>
        <td className="p-0" style={getBackgroundStyle(item?.status)}>
          <div
            className={`eye_area  ${item?.appointment_details?.extra_mileage_request == 1 &&
              "extra-mileage"
              }`}
            style={getEyeStyle(item?.status)}
          >
            <Link to={`/interpreter/appointments/view/${item?.id}`}>
              <i class="fa-solid fa-eye"></i>
            </Link>
          </div>
        </td>

        <td style={getBackgroundStyle(item?.status)}>
          {item?.appid ? (
            <Link
              className="link_preview"
              to={`/interpreter/appointments/view/${item?.id}`}
            >
              {item?.appid}
            </Link>
          ) : (
            "N/A"
          )}
        </td>
        <td
          style={getBackgroundStyle(item?.status)}
          className="text-transform-capitalize "
        >
          {item?.status || "N/A"}
        </td>
        <td style={getBackgroundStyle(item?.status)}>{item?.type || "N/A"}</td>
        <td style={getBackgroundStyle(item?.status)}>
          {formattedAppointmentDateTime}
        </td>
        <td style={getBackgroundStyle(item?.status)}>
          {item?.language?.name || "N/A"}
        </td>
        <td style={getBackgroundStyle(item?.status)}>
          {item?.accounts?.user?.name || "N/A"}
        </td>
      </tr>
    );
  }
);
export default ListTable;
